// Keep the Bruler page available when a visitor follows an external website link.
const storeHosts = new Set([location.hostname.replace(/^www\./, ''), 'bruler.co.uk', 'bruler-plumbing.myshopify.com']);
function markExternalLink(link) {
  if (!link.hasAttribute('href') || link.hasAttribute('download')) return;
  let url;
  try { url = new URL(link.getAttribute('href'), location.href); } catch { return; }
  if (!['https:', 'http:'].includes(url.protocol) || storeHosts.has(url.hostname.replace(/^www\./, ''))) return;
  link.target = '_blank';
  link.relList.add('noopener', 'noreferrer');
}
function markLinks(root) {
  if (root instanceof HTMLAnchorElement) markExternalLink(root);
  root.querySelectorAll?.('a[href]').forEach(markExternalLink);
}
markLinks(document);
new MutationObserver((records) => {
  for (const record of records) {
    if (record.type === 'attributes') markExternalLink(record.target);
    else record.addedNodes.forEach(markLinks);
  }
}).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
